import React from "react";
import { Link } from "react-router-dom";
import "../css/returns.scss";

function Returns() {
  return (
    <main className="ink-info-page ink-info-page--returns">
      <div className="ink-info-page__inner">
        <header className="ink-info-page__header">
          <p className="ink-info-page__eyebrow">We&apos;ll help make it right</p>
          <h1>Returns &amp; Refunds</h1>
          <p className="ink-info-page__lead">
            If you are not happy with your purchase, contact ioomparade so a
            return and refund can be arranged.
          </p>
          <p className="policy-updated">
            Effective and last updated: <time dateTime="2026-10-16">October 16, 2026</time>
          </p>
        </header>

        <section className="returns-window" aria-labelledby="returns-window-title">
          <div className="returns-window__number" aria-hidden="true">30</div>
          <div>
            <p className="ink-info-page__kicker">Return window</p>
            <h2 id="returns-window-title">30 days after delivery</h2>
            <p>
              Return requests must be made within 30 days after delivery.
              Please get in touch before sending an item back so the next steps
              can be arranged. Any longer non-excludable legal right still applies.
            </p>
          </div>
          <Link className="ink-info-page__button" to="/contact">
            Start a return
          </Link>
        </section>

        <section className="returns-steps" aria-labelledby="returns-steps-title">
          <div className="returns-steps__intro">
            <p className="ink-info-page__kicker">Simple next steps</p>
            <h2 id="returns-steps-title">How to request a return</h2>
          </div>
          <ol>
            <li>
              <span>01</span>
              <h3>Contact ioomparade</h3>
              <p>
                Send your order details and a short explanation through the
                contact page.
              </p>
            </li>
            <li>
              <span>02</span>
              <h3>Arrange the return</h3>
              <p>
                ioomparade will help arrange the refund and confirm what should
                happen next.
              </p>
            </li>
            <li>
              <span>03</span>
              <h3>Send it back when required</h3>
              <p>
                For a preference-based return, the recipient is responsible for
                shipping the item back.
              </p>
            </li>
          </ol>
        </section>

        <section className="returns-issues" aria-labelledby="returns-issues-title">
          <div>
            <p className="ink-info-page__kicker">Order issue?</p>
            <h2 id="returns-issues-title">Mistake or error in your order</h2>
          </div>
          <p>
            If ioomparade made a mistake or there is an error in your order,
            please let us know. The team will do its best to fix the problem.
          </p>
        </section>

        <section className="commerce-policy-details" aria-labelledby="returns-details-title">
          <div className="commerce-policy-details__heading">
            <p className="ink-info-page__kicker">Eligibility and refunds</p>
            <h2 id="returns-details-title">Return policy details</h2>
          </div>
          <div className="commerce-policy-details__grid">
            <article>
              <h3>Return condition</h3>
              <p>
                A preference-based return should be unused, unaltered, complete,
                and in its original condition with included parts and packaging.
                Handle an item only as reasonably needed to inspect it.
              </p>
            </article>
            <article>
              <h3>Proof of purchase</h3>
              <p>
                Include the order reference and the email used at checkout. We
                may request photographs or other proportionate information to
                identify the order and assess the request.
              </p>
            </article>
            <article>
              <h3>Return authorization</h3>
              <p>
                Contact us before sending anything. We will confirm whether a
                return is needed and provide the appropriate instructions. An
                item sent without authorization may be delayed or misdirected.
              </p>
            </article>
            <article>
              <h3>Return shipping</h3>
              <p>
                The customer pays return shipping for a change-of-mind return.
                When we accept that an item is defective, damaged in transit,
                incorrect, or materially misdescribed, we will provide or
                reimburse reasonable return shipping where required.
              </p>
            </article>
            <article>
              <h3>Inspection and refund</h3>
              <p>
                After an authorized return arrives, we inspect it and notify you
                of the outcome. An approved refund is sent to the original
                payment method where practicable. Banks and payment providers
                control the time needed for the credit to appear.
              </p>
            </article>
            <article>
              <h3>Original delivery charge</h3>
              <p>
                Original shipping may be refunded when required by law or when
                the entire order is returned because of our accepted error. It
                is normally not refundable for a preference-based return where
                the law permits.
              </p>
            </article>
            <article>
              <h3>Exchanges</h3>
              <p>
                Direct exchanges depend on stock and may not be available. We
                may instead refund an eligible return and ask you to place a new
                order for the preferred item.
              </p>
            </article>
            <article>
              <h3>Damaged, wrong, or missing items</h3>
              <p>
                Contact us within 7 days of delivery when practical, with clear
                photographs of the item, label, and packaging. This reporting
                request does not shorten a non-excludable legal right.
              </p>
            </article>
            <article>
              <h3>Abuse and mandatory rights</h3>
              <p>
                We may reject fraudulent, altered, substituted, or abusive return
                requests. Nothing in this policy excludes a remedy that applicable
                consumer law says cannot be excluded.
              </p>
            </article>
          </div>
        </section>

        <p className="returns-source-note">
          Need delivery information instead? <Link to="/shipping">View shipping details</Link>. For product faults, read the <Link to="/policies/warranty">Warranty &amp; Defective Items Policy</Link>.
        </p>
      </div>
    </main>
  );
}

export default Returns;
